export default __webpack_public_path__ + "img/portrait_2.76b5436691c8970e3a9e973b3fb2c0ca.jpg";